import { render, staticRenderFns } from "./bandEmail.vue?vue&type=template&id=3a1ca54c&scoped=true"
import script from "./bandEmail.vue?vue&type=script&lang=js"
export * from "./bandEmail.vue?vue&type=script&lang=js"
import style0 from "./bandEmail.vue?vue&type=style&index=0&id=3a1ca54c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1ca54c",
  null
  
)

export default component.exports